import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { LoginInfo } from '../../models/LoginInfo';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { BasicInfo } from '../../models/BasicInfo';
import { SpecialProvision } from '../../models/SpecialProvision';
import { ContractorInfo } from '../../models/ContractorInfo';
import { TravelerInfo } from '../../models/TravelerInfo';
import { OthersInfo } from '../../models/OthersInfo';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { FinishItemMode } from './mode/FinishItemMode';
import { PlanInfo } from '../../models/PlanInfo';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { CollateralInfo } from '../../models/CollateralInfo';
import { CollateralDisplayRequest } from '../../service/service-models/collateral-display/CollateralDisplayRequest';
import { PlanByTravelWLService } from '../../service/PlanByTravelWLService';
import { PaymentInfo } from '../../service/models/payment/payment-info';
import { CollateralDisplayResult } from '../../service/service-models/collateral-display/CollateralDisplayResult';
import { SystemService } from '../../service/SystemService';
import { HttpUtils } from '../../common/http/HttpUtils';

export let selectCompensationIdx: string = null;		// 担保インデックス
export let deathCompensationExists: boolean = false;	// 死亡補償フラグ

/**
 * 契約手続き完了ビュー情報
 */
export class FinishComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// モデル  ---------------------------------------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 						= null;						// 商品コード
	@WprDI_GlobalScopeModel('agentcode')
	private m_Agency: string 							= null;						// 代理店コード
	@WprDI_ScopeModel('LoginInfo')
	@WprModel('LoginInfo')
	private m_LoginInfo: LoginInfo 						= null; 					// ログイン情報
	@WprDI_ScopeModel('BasicInfo')
	@WprModel('BasicInfo')
	private m_BasicInfo: BasicInfo 						= null; 					// 基本情報
	@WprDI_ScopeModel('PlanInfo')
	@WprModel('PlanInfo')
	private m_PlanInfo: PlanInfo 						= null;						// プラン情報 
	@WprDI_ScopeModel('SpecialProvision')
	@WprModel('SpecialProvision')
	private m_SpecialProvision: SpecialProvision 		= null; 					// 特約・約款情報
	@WprDI_ScopeModel('ContractorInfo')
	@WprModel('ContractorInfo')
	private m_ContractorInfo: ContractorInfo 			= null; 					// 契約者（申込者）情報
	@WprDI_ScopeModel('TravelerInfo')
	@WprListData('TravelerInfo')
	@WprModel('TravelerInfo')
	private m_TravelerListInfo: TravelerInfo[] 			= null; 					// 旅行者（被保険者）リスト情報
	@WprDI_ScopeModel('ContractNoticeInfo')
	@WprListData('ContractNoticeInfo')
	@WprModel('ContractNoticeInfo')
	private m_ContractNoticeList: ContractNoticeInfo[] 	= null; 					// 告知事項情報
	@WprDI_ScopeModel('OthersInfo')
	@WprModel('OthersInfo')
	private m_OthersInfo: OthersInfo 					= null; 					// その他情報
	@WprDI_ScopeModel('payment')
	private m_Payment:string							= null;						// 支払い方法
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo: RiskFactorInfo 			= null;						// リスクファクター情報
	@WprDI_ScopeModel('SelectPlanInfo')
	private m_SelectPlanInfo: SelectPlanInfo 			= null;						// 選択プラン情報
	@WprDI_ScopeModel('CollateralInfo')
	@WprListData('CollateralInfo')
	@WprModel('CollateralInfo')
	private m_Collaterals: CollateralInfo[] 			= null;						// 補償表示情報
	@WprDI_ScopeModel('paymentType')
	private m_PaymentType:string						= null;						// 支払い方法
	@WprDI_GlobalScopeModel('AuthMailId')
	private m_AuthMailId: string							= null;
	// --------------------------------------------------------------------------------------------------------

	// サブビュー/モード ---------------------------------------------------------------------------------------
	@WprViewMode
	private m_ViewItemMode 								= new FinishItemMode(); 	// 保険項目切り替えモード
	// -------------------------------------------------------------------------------------------------------
	
	private m_PlanByTravelWLService: PlanByTravelWLService 	= new PlanByTravelWLService();	//　プランサーチサービス
	private m_SystemService: SystemService 					= new SystemService();			// システムサービス

	// コンストラクタ  ----------------------------------------------------------------------------------------
	public constructor() {
		super('step8_make-contract');
	}
	// --------------------------------------------------------------------------------------------------------

	// override メソッド --------------------------------------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		// ログイン情報
		this.addConfig('loginId', 'ログインID', 'LoginInfo');
		// 基本情報
		this.addConfig('contractNumber', '契約証番号', 'BasicInfo');
		this.addConfig('insuranceType', '保険種類', 'BasicInfo');
		this.addConfig('plan', '契約プラン', 'BasicInfo');
		this.addConfig('insuranceFee', '合計保険料（全員分）', 'BasicInfo');
		this.addConfig('insurancePeriod', '保険期間', 'BasicInfo');
		this.addConfig('applicationDate', '申込日', 'BasicInfo');
		// 補償内容
		this.addListConfig('collateralName', '表示補償名', 'CollateralInfo', { bindName: 'collateralName' });
		this.addListConfig('collateralAmount', '補償金額', 'CollateralInfo', { bindName: 'collateralAmount' });
		this.addListConfig('displayCollateralName', 'モーダル内補償名', 'CollateralInfo', { bindName: 'displayCollateralName' });
		this.addListConfig('collateralDescription', 'モーダル内補償説明', 'CollateralInfo', { bindName: 'collateralDescription' });
		// 告知事項
		this.addListConfig('noticeMessage', '告知事項メッセージ', 'ContractNoticeInfo');
		// 特約・約款
		this.addConfig('specialProvision', '特約・約款', 'SpecialProvision');
		// 契約者（申込者）情報
		this.addConfig('lastNameContractor', '姓（漢字・平仮名・カタカナ）', 'ContractorInfo', { bindName: 'lastName' });
		this.addConfig('firstNameContractor', '名（漢字・平仮名・カタカナ）', 'ContractorInfo', { bindName: 'firstName' });
		this.addConfig('romanLastNameContractor', '姓（ローマ字）', 'ContractorInfo', { bindName: 'romanLastName' });
		this.addConfig('romanFirstNameContractor', '名（ローマ字）', 'ContractorInfo', { bindName: 'romanFirstName' });
		this.addConfig('romanNameContractor', '契約者名（ローマ字）', 'ContractorInfo', { bindName: 'romanName' });
		this.addConfig('yearContractor', '年', 'ContractorInfo', { bindName: 'year' });
		this.addConfig('monthContractor', '月', 'ContractorInfo', { bindName: 'month' });
		this.addConfig('dateContractor', '日', 'ContractorInfo', { bindName: 'date' });
		this.addConfig('genderContractor', '性別', 'ContractorInfo', { bindName: 'gender' });
		this.addConfig('postalCode', '郵便番号', 'ContractorInfo');
		this.addConfig('prefecture', '都道府県', 'ContractorInfo');
		this.addConfig('address1', '住所1', 'ContractorInfo');
		this.addConfig('address2', '住所2', 'ContractorInfo');
		this.addConfig('tel', '電話番号', 'ContractorInfo');
		this.addConfig('mailAddress', 'メールアドレス', 'ContractorInfo');
		// 旅行者（記名被保険者）情報
		this.addListConfig('romanLastNameTraveler', '姓（ローマ字）', 'TravelerInfo', { bindName: 'romanLastName' });
		this.addListConfig('romanFirstNameTraveler', '名（ローマ字）', 'TravelerInfo', { bindName: 'romanFirstName' });
		this.addListConfig('yearTraveler', '年', 'TravelerInfo', { bindName: 'year' });
		this.addListConfig('monthTraveler', '月', 'TravelerInfo', { bindName: 'month' });
		this.addListConfig('dateTraveler', '日', 'TravelerInfo', { bindName: 'date' });
		this.addListConfig('genderTraveler', '性別', 'TravelerInfo', { bindName: 'gender' });
		this.addListConfig('recipient', '死亡保険金受取人', 'TravelerInfo');
		// その他
		this.addConfig('agency', '取扱代理店', 'OthersInfo');
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		this.addAction('q-loginId', this.onHelpShow);
		this.addListAction('question', 'CollateralInfo', this.onCollateralHelpShow);
		this.addAction('close', this.onClose);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		if (!this.m_ContractNoticeList || !this.m_Collaterals || !this.m_TravelerListInfo) {
			this.onViewError();
		}
		else {
			if (this.m_ProductCode === 'DTA' || this.m_ProductCode === 'DTP') {
				this.m_BasicInfo.insuranceType = '国内旅行傷害保険';
			}
			else {
				if (this.m_RiskFactorInfo.companyProductCode === 'DTA' || this.m_RiskFactorInfo.companyProductCode === 'DTP')
					this.m_BasicInfo.insuranceType = '国内旅行傷害保険';
				else
					this.m_BasicInfo.insuranceType = '海外旅行傷害保険';
			}
			// 補償表示情報リクエスト値取得
			this.setListData('ContractNoticeInfo', this.m_ContractNoticeList);
			this.setListData('CollateralInfo', this.m_Collaterals);
			this.setListData('TravelerInfo', this.m_TravelerListInfo);
			deathCompensationExists = this.deathCompensationExists(this.m_Collaterals);
			const collateralReq = this.getCollateralReq();
			this.m_PlanByTravelWLService.getCollateralDisplay(this, collateralReq, (result) => {
				const collateralRes: CollateralDisplayResult = result as CollateralDisplayResult;
				this.m_SpecialProvision.specialProvision = collateralRes.specialProvision;
				HttpUtils.finish('/finish');
				this.onUtagView();
				this.refreshView();
			});
		}
	}

	/**
	 * Tealium Utag View　追加処理
	 */
	public onExtraUtagView(utagView: any): void{
		this.setScopeModel('RiskFactorInfo', this.m_RiskFactorInfo);
		this.setScopeModel('SelectPlanInfo', this.m_SelectPlanInfo);
		utagView.quote_prev_expiry_date = this.m_RiskFactorInfo.startDate;
		utagView.quote_expiry_date = this.m_RiskFactorInfo.endDate;
		utagView.quote_amt = this.m_SelectPlanInfo.totalPremium;
		utagView.quote_id = this.m_AuthMailId;
		utagView.contract_amt = this.m_SelectPlanInfo.totalPremium;
		utagView.contract_paytype = this.m_Payment;
		utagView.endorser = this.m_Agency;
		utagView.plancode = this.m_SelectPlanInfo.planCode;
 		utagView.country = this.m_RiskFactorInfo.destinationCountryCode;
		utagView.number_of_parson = this.m_RiskFactorInfo.numberOfInsured;
		utagView.purpose = this.m_RiskFactorInfo.purposeCode;
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * ログインID用ヘルプ表示処理
	 */
	public onHelpShow(param: any): void {
		this.setViewMode('helpMode', param);
		this.refreshModel();
	}
	/**
	 * 補償用ヘルプ表示処理
	 */
	public onCollateralHelpShow(param: any, item: any){
		this.setViewMode('helpMode', item.collateralKey);
		const idx: number = this.m_Collaterals.indexOf(item);
		selectCompensationIdx = `${idx}`;
		this.refreshModel();
	}
	/**
	 * ヘルプ閉じる処理
	 */
	public onClose(param: any): void {
		this.setViewMode('helpMode', '');
		selectCompensationIdx = null;
		this.refreshModel();
	}
	// --------------------------------------------------------------------------
	
	// privateメソッド -----------------------------------------------------------
	/**
	 * 死亡補償が含まれているか判定
	 * AT04：疾病死亡（OTA）、AT21：傷害死亡（OTA）、AT30：傷害死亡・後遺障害（DTP）
	 * @param collaterals
	 * @returns 死亡補償が存在する場合true、ない場合false
	 */
	private deathCompensationExists(collaterals: CollateralInfo[]): boolean {
		for (let i = 0; i < collaterals.length; i++) {
			if (collaterals[i].collateralKey === 'AT04') {
				return true;
			}
			else if (collaterals[i].collateralKey === 'AT21') {
				return true;
			}
			else if (collaterals[i].collateralKey === 'AT30') {
				return true;
			}
		}
		return false;
	}

	/**
	 * CollateralDisplayRequest値セット
	 * @param collateralReq 
	 * @param riskFactorInfo 
	 * @param paymentInfo 
	 */
	private getCollateralReq(): CollateralDisplayRequest{
		let collateralReq: CollateralDisplayRequest = new CollateralDisplayRequest();
		// const today = new Date();
		const today = new Date(this.m_BasicInfo.applicationDate);
		collateralReq.riskFactorInfo = this.m_RiskFactorInfo;
		collateralReq.planCode = this.m_SelectPlanInfo.planCode;
		collateralReq.paymentInfo = new PaymentInfo();
		collateralReq.paymentInfo.paymentType = this.m_PaymentType;
		collateralReq.coverageCodeList = [];
		for (const collateral of this.m_Collaterals)
			collateralReq.coverageCodeList.push(collateral.collateralKey);
		return collateralReq;
	}
	// ---------------------------------------------------------------------------
}